import type { Settlement } from '../engine/map/settlement';
import { recordProduced } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { getBuildingStorage, getEffectiveOutputCap } from '../engine/settlement/utils';

export function runQuarryTick(settlement: Settlement): boolean {
    if (settlement.buildings.quarry.qty <= 0 || settlement.jobs.quarrymen <= 0) {
        const hadWork = settlement.production.quarry.progress.length > 0;
        settlement.production.quarry.progress = [];
        return hadWork;
    }
    let changed = false;
    const config = getGameConfig();
    const outputCap = getEffectiveOutputCap(settlement, config, 'quarry', 'stone');
    const storage = getBuildingStorage(settlement, 'quarry');
    while (settlement.production.quarry.progress.length < settlement.jobs.quarrymen) {
        settlement.production.quarry.progress.push(0);
        changed = true;
    }
    while (settlement.production.quarry.progress.length > settlement.jobs.quarrymen) {
        settlement.production.quarry.progress.pop();
        changed = true;
    }

    if (settlement.regionResources.stoneDeposit <= 0) return changed;

    const ticksPerStone = config.production.quarry.ticksPerStone;
    for (let i = 0; i < settlement.production.quarry.progress.length; i += 1) {
        if (settlement.regionResources.stoneDeposit <= 0) break;
        if (outputCap <= 0 || outputCap - storage.stone < 1) break;
        settlement.production.quarry.progress[i] += 1;
        if (settlement.production.quarry.progress[i] >= ticksPerStone) {
            settlement.production.quarry.progress[i] -= ticksPerStone;
            settlement.regionResources.stoneDeposit = Math.max(
                0,
                settlement.regionResources.stoneDeposit - 1,
            );
            storage.stone += 1;
            recordProduced(settlement, 'stone', 1);
            changed = true;
        }
    }

    return changed;
}
